"use client";

import React from "react";

import { SVGIcon } from "../SVGIcon";
import { createSVGIcon } from "../util";

/** @optimized using svgo:^3.0.2 */
export const DollarPriceTag = createSVGIcon(
  <>
    <path
      d="M18.502 5a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0ZM15.26 12.574l-1.985-1.985a1.11 1.11 0 0 0-1.686 0c-.925.924 1.2 4.46.272 5.384a1.17 1.17 0 0 1-1.687 0L8.19 13.988M13.844 11.157l1.06-1.061M8.541 16.46l1.061-1.062"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.852 12.646a1.206 1.206 0 0 0 0 1.708l8.792 8.792a1.206 1.206 0 0 0 1.708 0l11.44-11.439A2.42 2.42 0 0 0 24.497 10V1.5a1 1 0 0 0-1-1h-8.5a2.41 2.41 0 0 0-1.707.707z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>,
  "DollarPriceTag",
  { viewBox: "0 0 25 24", fill: "none" } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);

/** @optimized using svgo:^3.0.2 */
export const PoundPriceTag = createSVGIcon(
  <>
    <path
      d="M18.502 5a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.228 10.435a.396.396 0 0 0 0 .56l.46.46c-.298.514-.578.992-.974 1.389-.226.225-.452.36-.668.45-.541-.369-1.14-.304-1.596-.098-.25.114-.266.438-.071.633.168.168.437.162.673.127.214-.033.458.03.696.268.514.514.64 1.777 1.435 2.571.725.725 1.627.744 2.427.25.228-.14.236-.456.046-.645-.173-.173-.446-.17-.664-.058-.463.24-.858.088-1.241-.296-.388-.388-.613-1.299-1.065-2.039.244-.099.488-.252.704-.469.451-.45.767-.893 1.056-1.326l1.515 1.516a.396.396 0 1 0 .56-.56l-1.642-1.641c.298-.46.622-.93 1.11-1.417.74-.74 1.722-.73 2.417-.036.623.623.672 1.196.348 1.838-.12.241-.1.538.09.729.23.23.616.218.777-.066.57-1.006.414-2.153-.574-3.142-1.119-1.118-2.743-1.226-3.844-.126-.478.478-.82.966-1.11 1.435l-.306-.307a.396.396 0 0 0-.56 0"
      fill="currentColor"
    />
    <path
      d="M1.852 12.646a1.206 1.206 0 0 0 0 1.708l8.792 8.792a1.206 1.206 0 0 0 1.708 0l11.44-11.439A2.42 2.42 0 0 0 24.497 10V1.5a1 1 0 0 0-1-1h-8.5a2.41 2.41 0 0 0-1.707.707z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>,
  "PoundPriceTag",
  { viewBox: "0 0 25 24", fill: "none" } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);

/** @optimized using svgo:^3.0.2 */
export const EuroPriceTag = createSVGIcon(
  <>
    <path
      d="M18.502 5a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.627 10.372a.35.35 0 0 0-.007.494l.352.351-.673.673-.352-.352a.35.35 0 0 0-.493.007.35.35 0 0 0-.007.493l.378.377c-1.186 1.487-1.33 3.275-.047 4.557 1.042 1.042 2.388 1.19 3.669.393a.45.45 0 0 0 .07-.706c-.17-.17-.441-.182-.655-.057-.927.544-1.78.45-2.472-.242-.914-.914-.796-2.054.156-3.224l1.483 1.484a.35.35 0 0 0 .443.035.35.35 0 0 0 .057-.535L10.02 12.61l.673-.673 1.727 1.727a.346.346 0 0 0 .442.036.35.35 0 0 0 .058-.536l-1.71-1.71c1.178-.96 2.387-1.13 3.284-.233.643.644.748 1.469.293 2.296-.12.218-.11.491.063.663.206.207.556.183.709-.075.705-1.194.537-2.454-.479-3.47-1.324-1.325-3.13-1.078-4.583.107l-.377-.378a.35.35 0 0 0-.493.007"
      fill="currentColor"
    />
    <path
      d="M1.852 12.646a1.206 1.206 0 0 0 0 1.708l8.792 8.792a1.206 1.206 0 0 0 1.708 0l11.44-11.439A2.42 2.42 0 0 0 24.497 10V1.5a1 1 0 0 0-1-1h-8.5a2.41 2.41 0 0 0-1.707.707z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>,
  "EuroPriceTag",
  { viewBox: "0 0 25 24", fill: "none" } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);

const PriceTagVariantMap = {
  dollar: DollarPriceTag,
  pound: PoundPriceTag,
  euro: EuroPriceTag,
};

export interface IPriceTagProps extends SVGIcon.IProps {
  /**
   * Which variant of the price tag component to show
   * @default "dollar"
   */
  variant: keyof typeof PriceTagVariantMap;
}

export const PriceTag = React.memo(
  ({
    variant = "dollar",
    ref,
    ...iconProps
  }: IPriceTagProps & React.RefAttributes<SVGElement>) => {
    const IconComponent = PriceTagVariantMap[variant];
    return <IconComponent ref={ref} {...iconProps} />;
  }
);
